<section class="why-us-section section-padding">
  <div class="container">
    
    <!-- Section Header -->
    <div class="section-header reveal-on-scroll">
      <span class="subtitle">WHY BUILD WITH US?</span>
      <h2 class="title">YOUR HOME. YOUR WAY.</h2>
      <div class="gold-divider"></div>
      <p class="description">
        We don't believe one design fits everyone. Your home should reflect how you live, what you value and what you want for the future.
      </p>
    </div>

    <!-- 6 Pillar Grid -->
    <div class="pillars-grid">
      @for (p of pillars; track p.title; let i = $index) {
        <div class="pillar-card reveal-on-scroll" [class]="'delay-' + ((i % 3) + 1)">
          <div class="pillar-icon">
            @if (p.icon === 'award') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>
            } @else if (p.icon === 'message') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            } @else if (p.icon === 'ribbon') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            } @else if (p.icon === 'blueprint') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
            } @else if (p.icon === 'heart') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            } @else {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
            }
          </div>

          <h3 class="pillar-title">{{ p.title }}</h3>
          <p class="pillar-desc">{{ p.desc }}</p>
        </div>
      }
    </div>

  </div>
</section>
